import React, { useEffect, useState } from "react";

function InterviewTally({
  categories,
  formState,
  calculateTotalPoints,
  styles,
}) {
  const [object, setObject] = useState({});
  const [totalPoints, setTotal] = useState(0);

  useEffect(() => {
    setObject({ ...formState });
  }, [formState]);

  useEffect(() => {
    setTotal(calculateTotalPoints);
  }, [calculateTotalPoints]);

  return (
    <div style={{ marginTop: "1rem", padding: "1rem" }}>
      <label style={{ fontWeight: "bold", fontSize: styles.content.fontSize }}>
        Points per Category
      </label>
      <div
        style={{
          display: "flex",
          marginTop: "1rem",
        }}
      >
        {categories.map(({ label, key }) => (
          <div
            key={key}
            style={{
              marginLeft: "0.5rem",
              marginRight: "0.5rem",
              textAlign: "center",
            }}
          >
            <input
              type="text"
              value={object[key]}
              readOnly
              style={{
                width: "100%",
                border: "none",
                borderBottom: "1px solid #ccc",
                borderRadius: "0",
                textAlign: "center",
                padding: "0.25rem",
              }}
            />
            <label
              style={{
                marginTop: "0.5rem",
                color: "#6c757d",
                fontSize: styles.content.fontSize,
              }}
            >
              {label}
            </label>
          </div>
        ))}

        <div
          style={{
            marginLeft: "0.5rem",
            marginRight: "0.5rem",
            textAlign: "center",
          }}
        >
          <input
            type="text"
            value={totalPoints}
            readOnly
            style={{
              width: "100%",
              border: "none",
              borderBottom: "2px solid #000",
              borderRadius: "0",
              textAlign: "center",
              padding: "0.25rem",
              fontWeight: "bold",
            }}
          />
          <label
            style={{
              marginTop: "0.5rem",
              fontWeight: "bold",
              fontSize: styles.content.fontSize,
            }}
          >
            Total Points
          </label>
        </div>
      </div>
    </div>
  );
}

export default InterviewTally;
